import React, { useState, useEffect, useRef } from 'react';
import '../../../../pages/admin/admin_assets/css/Surveys.css';
import '../../../../pages/admin/admin_assets/css/responsive.css';
import Modal from 'react-bootstrap/Modal';
import enter_Arrow from '../../../../pages/admin/admin_assets/img/presskey.svg';
import preview_img from '../../../../pages/admin/admin_assets/img/preview.svg';
import share_img from '../../../../pages/admin/admin_assets/img/share.svg';
import add_img from '../../../../pages/admin/admin_assets/img/plus.svg';
import default_logo from '../../../../pages/admin/admin_assets/img/default_logo.jpg';
import { SmileOutlined } from '@ant-design/icons';
import { Button, Form, notification } from 'antd';
import { Breadcrumb } from 'antd';

import { useLocation } from 'react-router-dom';
import EmployeeResult from './PartnerResult';

const PartnerForms = (props) => {

    const [currentStep, setCurrentStep] = useState(0);
    const [showError, setShowError] = useState('');
    const [showStart, setShowStart] = useState(true);
    const [successMsg, setSuccessMsg] = useState(false);

    const [showOverlay, setOverlay] = useState(false)
    const [closeOverlay, setCloseOverlay] = useState()

  const [formData, setFormData] = useState({
     
        experienceRating: [],
      valuableCollaborationAspects: [],
      communicationOfMissionAndValues: [],
      collaborationImprovement: [],
      newMarketsOrSectors: [],  // Initialize as empty array
      collaborationChallenges: [],       // Initialize as empty array
      supportAndResourcesSatisfaction: [],   // Initialize as empty array
      communicationTransparency: [], 
      collaborationEnhancementAreas: [],
      strategicAlignment: [],
      conflictManagementFeedback: [],
      serviceReliability: [],
      additionalResources: [],
      
  });

  const questions = [
    {
        id: 1,
        questionText: "How would you rate your experience working with our brand?",
        answerKey: 'experienceRating',
        options: ['A Excellent', 'B Good', 'C Neutral', 'D Poor'],
        inputType: 'button'
    },
    {
        id: 2,
        questionText: "What aspects of our collaboration do you find most valuable?",
        answerKey: 'valuableCollaborationAspects',
        options: ['A Communication', 'B Flexibility', 'C Resources', 'D Shared Goals'],
        inputType: 'button'
    },
    {
        id: 3,
        questionText: "How well do we communicate our brand’s mission and values to you?",
        answerKey: 'communicationOfMissionAndValues',
        options: ['A Very Well', 'B Moderately Well', 'C Neutral', 'D Poorly'],
        inputType: 'button'
    },
    {
        id: 4,
        questionText: "How can we improve our collaboration to create more value?",
        answerKey: 'collaborationImprovement',
        options: ['A Better Communication', 'B Joint Initiatives', 'C More Resources', 'D Streamlined Processes'],
        inputType: 'button'
    },
    {
        id: 5,
        questionText: "What opportunities do you see for us to explore together in new markets or sectors?",
        answerKey: 'newMarketsOrSectors',
        options: ['A Emerging Markets', 'B Strategic Alliances', 'C Technology', 'D Diversification'],
        inputType: 'button'
    },
    {
        id: 6,
        questionText: "What challenges have you faced while working with us?",
        answerKey: 'collaborationChallenges',
        options: ['A Communication Gaps', 'B Resource Limitations', 'C Timeline Delays', 'D Misaligned Goals'],
        inputType: 'button'
    },
    {
        id: 7,
        questionText: "How satisfied are you with the level of support and resources provided by us?",
        answerKey: 'supportAndResourcesSatisfaction',
        options: ['A Very Satisfied', 'B Satisfied', 'CNeutral', 'D Dissatisfied'],
        inputType: 'button'
    },
    {
        id: 8,
        questionText: "How transparent and clear do you find our communication regarding project progress?",
        answerKey: 'communicationTransparency',
        options: ['A Very Clear', 'B Moderately Clear', 'C Neutral', 'D Unclear'],
        inputType: 'button'
    },
    {
        id: 9,
        questionText: "Are there any areas where we can streamline or enhance the collaboration process?",
        answerKey: 'collaborationEnhancementAreas',
        options: ['A Planning', 'B Resource Allocation', 'C Communication', 'D Decision-making'],
        inputType: 'button'
    },
    {
        id: 10,
        questionText: "How aligned do you feel our strategic objectives are with your business goals?",
        answerKey: 'strategicAlignment',
        options: ['A Strongly Aligned', 'B Moderately Aligned', 'C Neutral', 'D Not Aligned'],
        inputType: 'button'
    },
    {
        id: 11,
        questionText: "What feedback do you have regarding our approach to managing conflicts or disagreements?",
        answerKey: 'conflictManagementFeedback',
        options: ['A Excellent', 'B Good', 'C Average', 'D Poor'],
        inputType: 'button'
    },
    {
        id: 12,
        questionText: "How would you rate the reliability of our services or products in meeting your expectations?",
        answerKey: 'serviceReliability',
        options: ['A Highly Reliable', 'B Reliable', 'C Neutral', 'D Unreliable'],
        inputType: 'button'
    },
    {
        id: 13,
        questionText: "What additional resources, tools, or support would help you better collaborate with us?",
        answerKey: 'additionalResources',
        options: ['A Training', 'B Data Insights', 'C Marketing Materials', 'D Technology Solutions'],
        inputType: 'button'
    }
      
  ];
   
  useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                event.preventDefault();
                if (showStart) {
                    setShowStart(false);
                } else {
                    nextStep(formData[questions[currentStep].answerKey]);
                }
            }
        };
    
        window.addEventListener("keydown", handleKeyDown);
    
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [showStart, currentStep, formData, questions]); 
    

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({ ...prevState, [name]: value }));
        if (showError && value.trim() !== "") {
            setShowError('');
        }
    };

    const handleOptionClick = (answerKey, option) => {
        setFormData(prevState => ({
            ...prevState,
            [answerKey]: prevState[answerKey]
                ? prevState[answerKey].includes(option)
                    ? prevState[answerKey].filter(item => item !== option)
                    : [...prevState[answerKey], option]
                : [option] 
        }));
    };

    const nextStep = (currentInputValue) => {
        if ((typeof currentInputValue === 'string' && currentInputValue.trim() === "") ||
            (Array.isArray(currentInputValue) && currentInputValue.length === 0)) {
            setShowError('Required Field');
        } else {
            setShowError('');
            if (currentStep < questions.length - 1) {
                setCurrentStep(currentStep + 1);
            } else {
                handleSubmit();
            }
        };
    }

    const handleSubmit = () => {
        console.log(formData);
        setSuccessMsg('Form submitted. Check the console for data.');
    };

    // show copy link 
    const [showCopyLink, setShowCopyLink] = useState(false)

    const copyLink = ()=>{
        setShowCopyLink(true)
    }

  

        // file file and drag 

        const [selectedImage, setSelectedImage] = useState(false);

        const getFile = ((event)=>{
            console.log(event);
                setSelectedImage(URL.createObjectURL(event.target.files[0]))
        });

        const handleDragOver = (event) => {
            event.preventDefault(); // Prevent default behavior (prevent file from being opened)
        };
    
        const handleDrop = (event) => {
            event.preventDefault();
            const file = event.dataTransfer.files[0]; // Access files from the dataTransfer object
            if (file) {
                setSelectedImage(URL.createObjectURL(file));
            }
        };
        
        // file upload modal
        const [modalShow, setModalShow] = React.useState(false);

        function MyVerticallyCenteredModal(props) {
            return (
              <Modal
                {...props}
                size="lg"
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header closeButton className='border-0'>
             
                </Modal.Header>
                <Modal.Body>
                <div className='position-relative'>
                        <input 
                            type="file" 
                            onChange={getFile} 
                            onDragOver={handleDragOver} 
                            onDrop={handleDrop} 
                            className='upload_logo_modal'
                            style={{ width: '100%'}} // Style as needed
                        />
                        <div className='upload_txt'>
                            <p className='mb-0'>Upload or drop an image right here</p>
                            <p className="file-types mb-0">JPG, PNG, or GIF. Up to 4MB.</p>
                            
                        </div>
                        {selectedImage && (
                            <div className='preview_img'>
                                <img src={selectedImage} alt="Selected" style={{ width: '100%', marginTop: '10px' }} />
                            </div>
                        )}

                        <div className='update text-center'>
                            <button onClick={updateHandle}>Update</button>
                        </div>
                    </div>
                </Modal.Body>
              </Modal>
            );
          }

                          const [surveyTab, setSurveyTab] = useState(true)
                         const [resultTab, setResultTab] = useState(false)
                         
                         const [activeTab, setActiveTab] = useState('create')
                         const createHandle = ()=>{
                            setSurveyTab(true)
                            setResultTab(false)
                            setActiveTab('create')
                         }
                
                         const resultHandle = ()=>{
                           setResultTab(true)
                           setSurveyTab(false)
                           setActiveTab('result')
                
                       }
       
                    //      const createHandle = ()=>{
                    //         setSurveyTab(true)
                    //         setResultTab(false)
                    //         setActiveTab('create')
                    //      }
       
                    //      const resultHandle = ()=>{
                    //        setResultTab(true)
                    //        setSurveyTab(false)
                    //        setActiveTab('result')
       
                    //    }
                       const handleTabChange = (tab) => {
                           setActiveTab(tab);  // Set the active tab state
                       };
       
        //   hide copy link when preview icon clicked
        const [showPreview, setShowPreview] = useState()

        const hideCopyLink = ()=>{
            setShowPreview(false)
        }

              // adding overlay to the page
              const addBg = ()=>{
                setOverlay(true)
                setShowCopyLink(false)
                setFullForm('full_form')

            }

            const closePopOverlay = () =>{
                setOverlay(false)
                setFullForm(false)
            }

            // add new class for form
            const [fullForm, setFullForm] = useState()

            // Toast message to link copied
            const [api, contextHolder] = notification.useNotification();
            
            const openNotification = () => {
                api.open({
                    message: 'Your form link has been copied',
                //   description:
                //     'Your form link has been copied',
                  icon: (
                    <SmileOutlined
                      style={{
                        color: '#108ee9',
                      }}
                    />
                  ),
                });
              };

            // copy link clipboard text

            const [copyFormLink, setCopyFormLink] = useState('https://form.typeform.com/to/orl4Qfv7')

            const clickText = async ()=>
            {
                        try{
                                await window.navigator.clipboard.writeText(copyFormLink)
                                openNotification()
                        }

                        catch(error){
                            console.error('Unable to copy the clipboard', error)
                        }
            }

            const [successMessage, setSuccessMessage] = useState(false)

            const updateHandle=()=>{
                setSuccessMessage(true)
            }


  return (
    <div className='container-fluid'>

{ <Breadcrumb
                items={[
                {
                    title: 'Surveys ',
                    href: '#'
                },
                
                {
                    title: 'Partner',
                },
                ]}
            />}

            <div className='tabs_border survey_tabs'>
                    <button onClick={createHandle} className={activeTab==='create' ? 'tab_active' :''}>
                        <p>Create</p>
                     </button>
                    <button onClick={resultHandle} className={activeTab==='result' ? 'tab_active' :''}>
                        <p>Result</p>
                    </button>
            </div>

         {contextHolder}


                {
                    surveyTab ? (
<div className='form'>
        {
                showOverlay &&
                        <div className='overlay'>
                            <div className='' onClick={closePopOverlay}>
                                <p >
                                <img src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'><path fill='%23ffffff' d='M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z'/></svg>" alt="close"  style={{width:"19px"}}/>
                                </p>
                                </div>
                        </div>
        }
        {
            showCopyLink ? ( 
            <div className='copy_link_wrapper'>
                <div className='copy_link'>
                        <button onClick={clickText}><i class="fa fa-solid fa-link"></i> Copy</button>
                        <input type="text" value={copyFormLink}  onChange={(e)=>setCopyFormLink(e.target.value)}
                        />
                </div>    
            </div>

            ) : ("")
        }
        <div className={`form_wrapper ${fullForm ? "form_style" : ""}`}>
            <div className='row'>
                {
                    selectedImage ? (
                    <div className='log_upload'>
                        <img src={selectedImage} alt="" className='d_logo' />
                    </div>
                    ):
                    (
                       
                     <div className='log_upload'> 
                     <img src={default_logo} alt="" className='d_logo' />
                     </div>
                    ) 
                    
                }
                
                <div className='parent'>
                  
                <div className="form_sec">
                {
                 showOverlay &&
                    <div className='form_style_overlay'>
                        <div className='text-center' onClick={closePopOverlay}>
                            <p > <i class="fa fa-solid fa-xmark text-black"></i></p>
                            </div>
                    </div>
              }

                    {showStart ? 
                    (
                        <div className='start'>
                            <h3>We're Here to Help! [PartnerForm]</h3>
                            <p>Have questions or need assistance? Get in touch with us today.</p>
                            <div className='start_btn'>
                                <button onClick={() => setShowStart(false)}>Start</button>
                                <p>Press Enter <img src={enter_Arrow} alt="Enter Arrow" /></p>
                            </div>
                        </div>
                    ) 
                    : successMsg ?
                    (
                        <div className='success-message'>
                            <h4>
                            🎉 Thank You for Prebooking!
                            </h4>
                    <p>Our team will reach out to you shortly with further details. For questions, reach out at <a href='mailto:support@brewyourbrand.in'>support@brewyourbrand.in</a>  or call <a href="tel:+918150002200">+91 8150 00 22 00</a></p>
                        </div>
                    )
                    :
                    ((

                        <div className='question_form'>
                            <form onSubmit={handleSubmit}>
                                {questions.map((question, index) => (
                                    currentStep === index && (
                                        <div key={question.id}>
                                            <label>{question.id}. {question.questionText}</label>
                                            {question.inputType === 'button' ? 
                                                question.options.map(option => (
                                                    <div className='check_form'>
                                                    <div key={option}
                                                         className={`button-option ${formData[question.answerKey].includes(option) ? 'active' : ''}`}
                                                         onClick={() => handleOptionClick(question.answerKey, option)}>
                                                        {/* <span className="button-label">{option.charAt(0)}</span> */}
                                                         {option.slice(1)}
                                                    </div>
                                                    </div>
                                                )) : (
                                                    <div className='text_form'>
                                                    <input
                                                        type={question.inputType}
                                                        value={formData[question.answerKey]}
                                                        onChange={handleInputChange}
                                                        name={question.answerKey}
                                                    />
                                                    </div>
                                                )}
                                            <div className='next_prev'>
                                                {index > 0 && (
                                                    <button type="button" onClick={() => setCurrentStep(currentStep - 1)}>Previous</button>
                                                )}
                                                {index < questions.length - 1 ? (
                                                    <>
                                                    <button type="button" onClick={() => nextStep(formData[questions[currentStep].answerKey])}>Next</button>
                                                    </>
                                                ) : (
                                                    <button type="submit">Submit</button>
                                                )}
                                            </div>
                                            {showError && <p className="error">{showError}</p>}
                                        </div>
                                    )
                                ))}
                            </form>
                        </div>
                    )
                    )
                    }
                </div>
                <div className='edit_prev'>
                    <div className='right_wrapper'>
                            <div className='previous' onClick={addBg}>
                                <p>Preview</p>
                                 <img src={preview_img} alt="" />
                            </div>
                            <hr />
                            <div className='share' onClick={copyLink}>
                                <p>Share</p>
                                <img src={share_img} alt="" />

                            </div>
                    </div>

                    <div className='edit_wrapper'>
                        <div className='edit_sec'>
                            <h5 className='mb-0'>Edit Preferences</h5>
                         </div>

                        <div className='brand_wrapper' onClick={() => setModalShow(true)}>
                            <p>Brand Logo</p>
                            <img src={add_img} alt="" />
                        </div>
                        {
                            successMessage && 
                            <div className="upload_msg">
                            <p>updated successfully</p>
                                </div>
                        }
                             
                    </div>
                </div>
                </div>
            </div>
        </div>
        </div>
                    ) :

                    (
                        <div className=''>
                        <EmployeeResult/>
     </div> 
                    )
                }

        

             
            <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

    </div>
  )
}

export default PartnerForms